import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { ROLES } from '../../config/rolePermissions';

/** Default landing after sign-in — My Workspace is admin-only; others start on Kanban. */
export default function HomeRedirect() {
  const { user } = useAuth();
  const dest = user?.role === ROLES.ADMIN ? '/workspace' : '/kanban';
  return <Navigate to={dest} replace />;
}
